import React from 'react'
import { StaticImage } from "gatsby-plugin-image"

export function ProcessReviewSix() {
  return (
    <section className="position-relative">
      <div className="container-lg">
        <StaticImage className="d-none d-md-block middle-icon position-absolute top-50 start-50 translate-middle" alt="quote-circle" src="../../../images/process/home/quote-circle.png" imgClassName="middle-icon" />
        <div className="row">
          <div className="col-md-6 d-flex align-items-center justify-content-center text-with-quotes">
            <figure className="text-center px-2 mb-0 limited-width">
              <blockquote>I've wanted to get laser hair removal for years but wasn't sure who I could trust. I couldn't be happier that I decided to embark on my hair-free journey with Milan Laser.</blockquote>
              <figcaption><strong>- Connor H.</strong></figcaption>
            </figure>
          </div>
          <div className="col-md-6 d-flex align-items-center justify-content-center milan-py-lg">
            <StaticImage className="reviewer-img" alt="Connor H. Review" src="../../../images/process/home/connor.webp" />
          </div>
        </div>
      </div>
    </section>
  )
}

export default ProcessReviewSix